import { useEffect, useState } from 'react';

import type { MonitoringDetailSection } from './deviceDetailUtils';
import { useAuthStore } from '@/stores/authStore';

export function useDeviceDetailAccess() {
  const { user, actingOrgId, actualOrgId } = useAuthStore();
  const isAdminOrOwner = user?.role === 'ADMIN' || user?.role === 'SUPERADMIN';

  return {
    isAdminOrOwner,
    canControlDevice: isAdminOrOwner || user?.role === 'OPERATOR',
    canAnnotateConditionHistory:
      isAdminOrOwner || user?.role === 'OPERATOR',
    orgId: actingOrgId ?? actualOrgId ?? user?.organization_id ?? null,
  };
}

export function usePipelineDisclosureState({
  deviceId,
  activeSection,
  canManage,
}: {
  deviceId: number;
  activeSection: MonitoringDetailSection;
  canManage: boolean;
}) {
  const [controlsOpen, setControlsOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  useEffect(() => {
    setControlsOpen(false);
    setHistoryOpen(false);
  }, [deviceId]);

  return {
    deploymentsEnabled:
      canManage && activeSection === 'pipeline' && controlsOpen,
    historyEnabled:
      activeSection === 'pipeline' && (controlsOpen || historyOpen),
    onControlsOpenChange: setControlsOpen,
    onHistoryOpenChange: setHistoryOpen,
  };
}
